import axios from "axios";
import authHeader from "./auth-header";
import AuthService from "./auth.service";
import { config } from "../config";

class SparsService {
  url = `${config["apiUrl"]}serviceParts/`;
  getBrands() {
    return axios
      .get(`${this.url}brands`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getBrandsByStatus(status) {
    return axios
      .get(`${this.url}brands/status/${status}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  newBrand(bodyparms) {
    return axios
      .post(`${this.url}brands`, bodyparms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  updateBrand(id, bodyparms) {
    return axios
      .put(`${this.url}brands/${id}`, bodyparms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getSuppliers() {
    return axios
      .get(`${this.url}suppliers`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getSuppliersByStatus(status) {
    return axios
      .get(`${this.url}suppliers/status/${status}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  newSupplier(bodyparms) {
    return axios
      .post(`${this.url}suppliers`, bodyparms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  updateSupplier(id, bodyparms) {
    return axios
      .put(`${this.url}suppliers/${id}`, bodyparms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getProductFamilies(params = {}) {
    return axios
      .get(`${this.url}productfamilies`, {
        headers: authHeader(),
        params: {
          ...params,
        },
      })
      .then((response) => response.data)
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        throw error;
      });
  }

  getProductFamiliesByStatus(status) {
    return axios
      .get(`${this.url}productfamilies/status/${status}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  newProductFamily(bodyparms) {
    let headers = authHeader();
    if (bodyparms instanceof FormData) {
      headers["Content-Type"] = "multipart/form-data";
    }
    return axios
      .post(`${this.url}productfamilies`, bodyparms, {
        headers: headers,
      })
      .then((response) => {
        this.lastError = null;
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        this.lastError = error.response ? error.response.data : null;
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response ? error.response.data : error);
        return null;
      });
  }

  changeCategoryProductSiteStatus(id, params) {
    return axios
      .patch(`${this.url}productfamilies/${id}/productsSiteStatus`, params, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  updateProductFamilies(id, bodyparms) {
    let headers = authHeader();
    let method = 'put';
    if (bodyparms instanceof FormData) {
      headers["Content-Type"] = "multipart/form-data";
      method = 'post';
      bodyparms.append('_method', 'PUT');
    }

    return axios({
      method: method,
      url: `${this.url}productfamilies/${id}`,
      data: bodyparms,
      headers: headers,
    })
      .then((response) => {
        this.lastError = null;
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        this.lastError = error.response ? error.response.data : null;
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response ? error.response.data : error);
        return null;
      });
  }

  removeProductFamilyImage(id) {
    return axios
      .delete(`${this.url}productfamilies/${id}/image`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response ? error.response.data : error);
        return null;
      });
  }

  getEquipaments(page = 1, filters = {}) {
    return axios
      .get(`${this.url}equipments`, {
        headers: authHeader(),
        params: {
          page,
          per_page: 25,
          ...filters,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error?.response?.data || error.message);
        return null;
      });
  }

  getEquipamentsByStatus(status) {
    return axios
      .get(`${this.url}equipments/status/${status}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  importEquipmentsCsv(formData) {
    let headers = authHeader();
    headers["Content-Type"] = "multipart/form-data";
    return axios
      .post(`${this.url}equipments/import-csv`, formData, {
        headers: headers,
      })
      .then((response) => response.data)
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response ? error.response.data : error);
        throw error;
      });
  }

  getEquipmentCsvImportBatch(batchId) {
    return axios
      .get(`${this.url}equipments/import-csv/batches/${batchId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        throw error;
      });
  }

  cancelEquipmentCsvImportBatch(batchId) {
    return axios.post(
      `${this.url}equipments/import-csv/batches/${batchId}/cancel`,
      {},
      { headers: authHeader() }
    ).then((response) => response.data);
  }

  createImageImport(mode, expectedCount) {
    return axios.post(
      `${this.url}image-imports`,
      { mode, expected_count: expectedCount },
      { headers: authHeader() }
    ).then((response) => response.data);
  }

  uploadImageImportChunk(importId, files, chunkId, startSequence, onUploadProgress) {
    const formData = new FormData();
    files.forEach(file => formData.append("files[]", file, file.name));
    formData.append("chunk_id", chunkId);
    formData.append("start_sequence", startSequence);

    const headers = authHeader();
    headers["Content-Type"] = "multipart/form-data";
    return axios.post(`${this.url}image-imports/${importId}/chunks`, formData, {
      headers,
      onUploadProgress,
    }).then((response) => response.data);
  }

  finalizeImageImport(importId) {
    return axios.post(
      `${this.url}image-imports/${importId}/finalize`,
      {},
      { headers: authHeader() }
    ).then((response) => response.data);
  }

  getImageImport(importId) {
    return axios.get(`${this.url}image-imports/${importId}`, {
      headers: authHeader(),
    }).then((response) => response.data);
  }

  getImageImportItems(importId, params = {}) {
    return axios.get(`${this.url}image-imports/${importId}/items`, {
      headers: authHeader(),
      params,
    }).then((response) => response.data);
  }

  cancelImageImport(importId) {
    return axios.post(
      `${this.url}image-imports/${importId}/cancel`,
      {},
      { headers: authHeader() }
    ).then((response) => response.data);
  }

  renameImageImportItem(importId, itemId, matchingKey) {
    return axios.patch(
      `${this.url}image-imports/${importId}/items/${itemId}`,
      { matching_key: matchingKey },
      { headers: authHeader() }
    ).then((response) => response.data);
  }

  retryImageImportItem(importId, itemId) {
    return axios.post(
      `${this.url}image-imports/${importId}/items/${itemId}/retry`,
      {},
      { headers: authHeader() }
    ).then((response) => response.data);
  }

  deleteImageImportItem(importId, itemId) {
    return axios.delete(`${this.url}image-imports/${importId}/items/${itemId}`, {
      headers: authHeader(),
    }).then((response) => response.data);
  }

  getGalleryImages(type, params = {}) {
    return axios.get(`${this.url}images`, {
      headers: authHeader(),
      params: { ...params, type },
    }).then((response) => response.data);
  }

  deleteGalleryImage(type, fileId) {
    return axios.delete(`${this.url}images/${type}/${fileId}`, {
      headers: authHeader(),
    }).then((response) => response.data);
  }

  newEquipaments(bodyparms) {
    let headers = authHeader();
    headers["Content-Type"] = "multipart/form-data";
    return axios
      .post(`${this.url}equipments`, bodyparms, {
        headers: headers,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  updateEquipaments(id, bodyparms) {
    let headers = authHeader();
    headers["Content-Type"] = "multipart/form-data";

    return axios
      .post(`${this.url}equipments/${id}`, bodyparms, {
        headers: headers,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getEquipamentsPartsFomApi(equipamentId) {
    return axios
      .get(`${this.url}equipments/${equipamentId}/parts/apiSearch`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }

        console.log("ERROR:: ", error.response.data);
        throw new Error(error.response.data.message || "Error fetching equipment parts from API");
      });
  }

  getEquipamentProducts(id, params = {}) {
    return axios
      .get(`${this.url}equipments/${id}/products`, {
        headers: authHeader(),
        params: {
          ...params
        }
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response ? error.response.data : error);
        return null;
      });
  }

  removeEquipmentFile(equipmentId, fileId) {
    return axios
      .delete(`${this.url}equipments/${equipmentId}/file/${fileId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  deleteEquipment(id) {
    return axios
      .delete(`${this.url}equipments/${id}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response ? error.response.data : error);
        return null;
      });
  }

  bulkDeleteEquipments(ids) {
    return axios
      .post(
        `${this.url}equipments/bulk-delete`,
        { ids },
        {
          headers: authHeader(),
        }
      )
      .then((response) => response.data);
  }

  getEquipmentBulkDeleteBatch(batchId) {
    return axios
      .get(
        `${this.url}equipments/bulk-delete/batches/${batchId}`,
        { headers: authHeader() }
      )
      .then((response) => response.data);
  }

  cancelEquipmentBulkDeleteBatch(batchId) {
    return axios.post(
      `${this.url}equipments/bulk-delete/batches/${batchId}/cancel`,
      {},
      { headers: authHeader() }
    ).then((response) => response.data);
  }

  getProducts(params = {}) {
    return axios
      .get(`${this.url}products`, {
        headers: authHeader(),
        params: {
          ...params
        }
      })
      .then((response) => response.data)
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        throw error;
      });
  }

  getProduct(id) {
    return axios
      .get(`${this.url}products/${id}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response ? error.response.data : error);
        return null;
      });
  }

  deleteProduct(id) {
    return axios.delete(`${this.url}products/${id}`, {
      headers: authHeader(),
    }).then((response) => response.data);
  }

  bulkDeleteProducts(ids) {
    return axios.post(
      `${this.url}products/bulk-delete`,
      { ids },
      { headers: authHeader() }
    ).then((response) => response.data);
  }

  getProductBulkDeleteBatch(batchId) {
    return axios.get(
      `${this.url}products/bulk-delete/batches/${batchId}`,
      { headers: authHeader() }
    ).then((response) => response.data);
  }

  cancelProductBulkDeleteBatch(batchId) {
    return axios.post(
      `${this.url}products/bulk-delete/batches/${batchId}/cancel`,
      {},
      { headers: authHeader() }
    ).then((response) => response.data);
  }

  getTaxRuleGroups() {
    return axios
      .get(`${this.url}products/tax-rule-groups`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response?.data || error.message);
        throw error;
      });
  }

  getProductsByStatus(status) {
    return axios
      .get(`${this.url}products/status/${status}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  newProduct(bodyparms) {
    let headers = authHeader();
    if (bodyparms instanceof FormData) {
      headers["Content-Type"] = "multipart/form-data";
    }
    return axios
      .post(`${this.url}products`, bodyparms, {
        headers: headers,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response ? error.response.data : error);
        return null;
      });
  }

  updateProduct(id, bodyparms) {
    let headers = authHeader();
    let method = 'put';
    let url = `${this.url}products/${id}`;
    if (bodyparms instanceof FormData) {
      headers["Content-Type"] = "multipart/form-data";
      method = 'post';
      bodyparms.append('_method', 'PUT');
    }
    return axios({
      method: method,
      url: url,
      data: bodyparms,
      headers: headers
    })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response ? error.response.data : error);
        return null;
      });
  }

  removeProductImage(id) {
    return axios
      .delete(`${this.url}products/${id}/image`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response ? error.response.data : error);
        return null;
      });
  }

  changeProductSiteStatus(id, params) {
    return axios
      .patch(`${this.url}products/${id}/siteStatus`, params, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getEquipamentsProducts() {
    return axios
      .get(`${this.url}equipmentproducts`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  newEquipamentsProduct(bodyparms) {
    return axios
      .post(`${this.url}equipmentproducts`, bodyparms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  updateEquipamentsProduct(id, bodyparms) {
    return axios
      .put(`${this.url}equipmentproducts/${id}`, bodyparms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  syncRelationEquipmentProducts(equipamentId, params) {
    return axios
      .patch(
        `${this.url}equipment-products/relation`,
        {
          equipment_id: equipamentId,
          ...params
        },
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getRelatedProducts() {
    return axios
      .get(`${this.url}relatedproducts`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  newRelatedProducts(bodyparms) {
    return axios
      .post(`${this.url}relatedproducts`, bodyparms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  updateRelatedProducts(id, bodyparms) {
    return axios
      .put(`${this.url}relatedproducts/${id}`, bodyparms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  syncProductsStore() {
    return axios
      .get(`${this.url}syncToStore`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  syncImagesEquipmentsStore() {
    return axios
      .get(`${this.url}syncImagesToStore`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getCategories() {
    return axios
      .get(`${this.url}categories`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  importCategories() {
    return axios
      .get(`${this.url}categories/import`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response ? error.response.data : error);
        return null;
      });
  }

  getCategoryImportBatch(batchId) {
    return axios
      .get(`${this.url}categories/import/batches/${batchId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        throw error;
      });
  }

  cancelCategoryImportBatch(batchId) {
    return axios
      .post(
        `${this.url}categories/import/batches/${batchId}/cancel`,
        {},
        { headers: authHeader() }
      )
      .then((response) => response.data);
  }

  importBrands() {
    return axios
      .get(`${this.url}brands/import`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  importSuppliers() {
    return axios
      .get(`${this.url}suppliers/import`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getCategoriesByStatus(status) {
    return axios
      .get(`${this.url}categories/status/${status}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  newCategory(bodyparms) {
    let headers = authHeader();
    if (bodyparms instanceof FormData) {
      headers["Content-Type"] = "multipart/form-data";
    }
    return axios
      .post(`${this.url}categories`, bodyparms, {
        headers: headers,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response ? error.response.data : error);
        return null;
      });
  }

  updateCategory(id, bodyparms) {
    let headers = authHeader();
    let method = 'put';
    let url = `${this.url}categories/${id}`;
    if (bodyparms instanceof FormData) {
      headers["Content-Type"] = "multipart/form-data";
      method = 'post';
      bodyparms.append('_method', 'PUT');
    }
    return axios({
      method: method,
      url: url,
      data: bodyparms,
      headers: headers
    })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response ? error.response.data : error);
        return null;
      });
  }

  removeCategoryImage(id) {
    return axios
      .delete(`${this.url}categories/${id}/image`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response ? error.response.data : error);
        return null;
      });
  }

  deleteCategory(id, force = false) {
    return axios
      .delete(`${this.url}categories/${id}`, {
        headers: authHeader(),
        params: { force: force ? 1 : 0 }
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response?.data || error.message);
        throw error;
      });
  }

  deleteBrand(id, force = false) {
    return axios
      .delete(`${this.url}brands/${id}`, {
        headers: authHeader(),
        params: { force: force ? 1 : 0 }
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response?.data || error.message);
        return null;
      });
  }

  deleteSupplier(id, force = false) {
    return axios
      .delete(`${this.url}suppliers/${id}`, {
        headers: authHeader(),
        params: { force: force ? 1 : 0 }
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response?.data || error.message);
        return null;
      });
  }

  getConfigurations() {
    return axios
      .get(`${this.url}configurations`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response?.data || error.message);
        return null;
      });
  }

  updateConfiguration(id, bodyparms) {
    return axios
      .put(`${this.url}configurations/${id}`, bodyparms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response?.data || error.message);
        return null;
      });
  }

  bulkUpdateConfigurations(bodyparms) {
    let headers = authHeader();
    // If bodyparms is a FormData instance, use multipart/form-data header
    if (bodyparms instanceof FormData) {
      headers["Content-Type"] = "multipart/form-data";
    }
    return axios
      .post(`${this.url}configurations/bulk`, bodyparms, {
        headers: headers,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response?.data || error.message);
        throw error;
      });
  }

  removeConfigurationFile(code) {
    return axios
      .delete(`${this.url}configurations/file/${code}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response?.data || error.message);
        return null;
      });
  }
}
export default new SparsService();
